import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "demo-app" }
const _hoisted_2 = { class: "demo-app-sidebar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "demo-app-sidebar-section" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Instructions"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Select dates and you will be prompted to create a new event"),
    /*#__PURE__*/_createElementVNode("li", null, "Drag, drop, and resize events"),
    /*#__PURE__*/_createElementVNode("li", null, "Click an event to delete it")
  ])
], -1)
const _hoisted_4 = { class: "demo-app-sidebar-section" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = { class: "demo-app-sidebar-section" }
const _hoisted_7 = { class: "demo-app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.calendarOptions.weekends,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleWeekendsToggle && _ctx.handleWeekendsToggle(...args)))
          }, null, 40, _hoisted_5),
          _createTextVNode(" toggle weekends ")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", null, "All Events (" + _toDisplayString(_ctx.currentEvents.length) + ")", 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentEvents, (event) => {
            return (_openBlock(), _createElementBlock("li", {
              key: event.id
            }, [
              _createElementVNode("b", null, _toDisplayString(event.startStr), 1),
              _createElementVNode("i", null, _toDisplayString(event.title), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_FullCalendar, {
        class: "demo-app-calendar",
        options: _ctx.calendarOptions
      }, {
        eventContent: _withCtx((arg) => [
          _createElementVNode("b", null, _toDisplayString(arg.timeText), 1),
          _createElementVNode("i", null, _toDisplayString(arg.event.title), 1)
        ]),
        _: 1
      }, 8, ["options"])
    ])
  ]))
}